import React from 'react';
import {
    Create,
    SimpleForm,
    SelectInput,
    ReferenceInput,
    TextInput,
    DateInput,
    required,
    FormDataConsumer,
    useRedirect,
    useNotify,
} from 'react-admin';
import moment from 'moment';

import ErrorBoundary from '../ErrorBoundary';

const ORIGIN_TYPES = [
    { id: 'VENDOR', name: 'Vendor' },
    { id: 'SITE', name: 'Site' },
];

const CARRIERS = [
    { id: 'FedEx', name: 'FedEx' },
    { id: 'UPS', name: 'UPS' },
    { id: 'USPS', name: 'USPS' },
    { id: 'DHL', name: 'DHL' },
    { id: 'Courier', name: 'Courier' },
    { id: 'Other', name: 'Other' },
];

/**
 * New Supply Shipment. Saving opens the manifest - receipt lines are added on
 * the next screen, then the manifest is finalized to move stock into inventory.
 */
const ShipmentCreate = props => {
    const redirect = useRedirect();
    const notify = useNotify();

    const onSuccess = ({ data }) => {
        notify('Shipment created - add the receipt lines, then finalize');
        redirect(`/supplyshipments/${data.id}/show`);
    };

    return (
        <ErrorBoundary>
            <Create {...props} title="New Supply Shipment" onSuccess={onSuccess}>
                <SimpleForm
                    initialValues={{
                        origin_type: 'VENDOR',
                        receipt_date: moment().format('YYYY-MM-DD'),
                    }}
                    redirect="show"
                >
                    <SelectInput
                        source="origin_type"
                        label="Origin Type"
                        choices={ORIGIN_TYPES}
                        validate={required()}
                    />

                    <FormDataConsumer>
                        {({ formData, ...rest }) =>
                            formData.origin_type === 'SITE' ? (
                                <TextInput
                                    source="origin_site"
                                    label="Origin Site"
                                    validate={required()}
                                    {...rest}
                                />
                            ) : (
                                <ReferenceInput
                                    source="vendor_id"
                                    label="Origin Vendor"
                                    reference="supplyvendors"
                                    filter={{ status: 1 }}
                                    sort={{ field: 'name', order: 'ASC' }}
                                    perPage={200}
                                    validate={required()}
                                    {...rest}
                                >
                                    <SelectInput optionText="name" />
                                </ReferenceInput>
                            )
                        }
                    </FormDataConsumer>

                    <DateInput source="ship_date" label="Ship Date" />
                    <DateInput source="receipt_date" label="Receipt Date" validate={required()} />
                    <SelectInput source="carrier" label="Carrier" choices={CARRIERS} />
                    <TextInput source="po_no" label="PO #" />
                    <TextInput source="ref_no" label="Ref #" />
                </SimpleForm>
            </Create>
        </ErrorBoundary>
    );
};

export default ShipmentCreate;
